var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebsite = function SvgWebsite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "#fff",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m8.364 8.864-1.637 4.909 4.91-1.637M8.364 8.864l3.272 3.272M8.365 8.864l1.227-.41m2.046 3.682.468-1.406M9.591 8.455l2.514 2.275M9.591 8.455l1.636-.546m.878 2.821.51-1.531m-1.388-1.29 2.046-.682-.657 1.972m-1.389-1.29 1.389 1.29m4.748 1.301a7.364 7.364 0 1 1-14.728 0 7.364 7.364 0 0 1 14.728 0Z"
  })));
};
export default SvgWebsite;